import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { ExternalLink } from 'lucide-react';

const MentorshipLinkManager = ({ API_URL }) => {
  const [link, setLink] = useState('');
  const [saving, setSaving] = useState(false);
  const [lastUpdated, setLastUpdated] = useState('');

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${API_URL}/api/admin/mentorship-config`);
        const data = await res.json();
        if (data.config) {
          setLink(data.config.link || '');
          setLastUpdated(data.config.updated_at || '');
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchConfig();
  }, [API_URL]);

  const saveLink = async () => {
    if (!link.trim()) return;
    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/mentorship-config`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ link: link.trim() })
      });
      const data = await res.json();
      if (data.status === 'success') {
        setLastUpdated(new Date().toISOString());
        alert('Mentorship link updated successfully!');
      }
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="bg-white">
      <CardHeader>
        <CardTitle className="text-gray-900 flex items-center">
          <ExternalLink className="w-4 h-4 mr-2" />
          Mentorship Program Link
        </CardTitle>
        <CardDescription className="text-gray-600">
          Update the mentorship enrollment link (changes every month)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div>
            <label className="text-sm font-medium text-gray-700">Current Enrollment Link</label>
            <div className="flex gap-2 mt-1">
              <input
                type="url"
                value={link}
                onChange={e => setLink(e.target.value)}
                placeholder="https://www.upsurge.club/live-mentorship/..."
                className="flex-1 px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                data-testid="mentorship-link-input"
              />
              <Button
                onClick={saveLink}
                disabled={saving || !link.trim()}
                className="bg-blue-600 hover:bg-blue-700 text-white"
                data-testid="save-mentorship-link-btn"
              >
                {saving ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
          {lastUpdated && (
            <p className="text-xs text-gray-400">
              Last updated: {new Date(lastUpdated).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
            </p>
          )}
          <p className="text-xs text-gray-500 bg-yellow-50 border border-yellow-200 p-2 rounded">
            This link is displayed on the landing page Mentorship section. Update it at the start of each new batch.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default MentorshipLinkManager;
